unit search.dieseldepots;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Controls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid, WEBLib.DB,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons, WEBLib.TMSWEBCustomComponent,
  WEBLib.TMSWEBStateManager, WEBLib.TMSWEBResponsiveManager, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCDataGrid;

type
  TfrmSearchDieselDepots = class(TForm)
    wcSearch: TXDataWebClient;
    qSearch: TXDataWebDataSet;
    dsSearch: TDataSource;
    qSearchNo: TIntegerField;
    qSearchName: TStringField;
    qSearchSuspended: TBooleanField;
    wpMain: TPanel;
    WebLabel1: TLabel;
    WebPanel1: TPanel;
    btnBack: TSpeedButton;
    btnSelect: TSpeedButton;
    weSearch: TEdit;
    qSearchSupplierName: TStringField;
    qSearchSupplierCode: TStringField;
    gSearch: TTMSFNCDataGrid;
    dgaSearch: TTMSFNCDataGridDatabaseAdapter;
    procedure btnBackClick(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure qSearchAfterOpen(DataSet: TDataSet);
    procedure weSearchChange(Sender: TObject);
    procedure gSearchClick(Sender: TObject);
  private
    { Private declarations }

  public
    { Public declarations }
    bSuspended : Boolean;
    sCode,
    sName : String;
    procedure GetData;
  protected procedure LoadDFMValues; override; end;

var
  frmSearchDieselDepots: TfrmSearchDieselDepots;

implementation

{$R *.dfm}

uses
  stfmssystem.connection;

procedure TfrmSearchDieselDepots.btnBackClick(Sender: TObject);
begin
  sCode := '';
  sName := '';
  Close;
end;

procedure TfrmSearchDieselDepots.btnSelectClick(Sender: TObject);
begin
  sCode := qSearch.FieldByName('No').AsString;
  sName := qSearch.FieldByName('Name').AsString;
  Close;
end;

procedure TfrmSearchDieselDepots.GetData;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qSearch.Close;
    qSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qSearch.Open;
  end;
begin
  wcSearch.RawInvoke('IstfmssearchService.GetDieselDepots', [bSuspended, -1], @OnResult);
  weSearch.SetFocus;
end;

procedure TfrmSearchDieselDepots.qSearchAfterOpen(DataSet: TDataSet);
begin
  dgaSearch.Active := True;
end;

procedure TfrmSearchDieselDepots.gSearchClick(Sender: TObject);
begin
  weSearch.Text := '';
  weSearch.SetFocus;
end;

procedure TfrmSearchDieselDepots.weSearchChange(Sender: TObject);
  var
    I : Integer;
begin
  if weSearch.Text <> '' then
    begin
      For I := 0 to gSearch.SelectedColumnCount - 1 do
        begin
          If gSearch.SelectedColumns[I] then
            begin
              Case I of
               0 : qSearch.Locate('No', weSearch.Text, [loPartialKey]);
               1 : qSearch.Locate('Name', weSearch.Text, [loPartialKey]);
              End;
            end;
        end;
    end;
end;

procedure TfrmSearchDieselDepots.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wpMain := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnBack := TSpeedButton.Create(Self);
  btnSelect := TSpeedButton.Create(Self);
  weSearch := TEdit.Create(Self);
  gSearch := TTMSFNCDataGrid.Create(Self);
  dgaSearch := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcSearch := TXDataWebClient.Create(Self);
  qSearch := TXDataWebDataSet.Create(Self);
  qSearchNo := TIntegerField.Create(Self);
  qSearchName := TStringField.Create(Self);
  qSearchSuspended := TBooleanField.Create(Self);
  qSearchSupplierName := TStringField.Create(Self);
  qSearchSupplierCode := TStringField.Create(Self);
  dsSearch := TDataSource.Create(Self);

  wpMain.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  btnSelect.BeforeLoadDFMValues;
  weSearch.BeforeLoadDFMValues;
  gSearch.BeforeLoadDFMValues;
  dgaSearch.BeforeLoadDFMValues;
  wcSearch.BeforeLoadDFMValues;
  qSearch.BeforeLoadDFMValues;
  qSearchNo.BeforeLoadDFMValues;
  qSearchName.BeforeLoadDFMValues;
  qSearchSuspended.BeforeLoadDFMValues;
  qSearchSupplierName.BeforeLoadDFMValues;
  qSearchSupplierCode.BeforeLoadDFMValues;
  dsSearch.BeforeLoadDFMValues;
  try
    Name := 'frmSearchDieselDepots';
    Width := 480;
    Height := 480;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    wpMain.SetParentComponent(Self);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 480;
    wpMain.Height := 480;
    wpMain.Align := alClient;
    wpMain.Color := clSilver;
    wpMain.TabOrder := 0;
    WebLabel1.SetParentComponent(wpMain);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 480;
    WebLabel1.Height := 32;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Search Diesel Depots';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.Layout := tlCenter;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 398;
    WebPanel1.Width := 480;
    WebPanel1.Height := 82;
    WebPanel1.Align := alBottom;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := clSilver;
    WebPanel1.TabOrder := 0;
    btnBack.SetParentComponent(WebPanel1);
    btnBack.Name := 'btnBack';
    btnBack.Left := 330;
    btnBack.Top := 38;
    btnBack.Width := 108;
    btnBack.Height := 35;
    btnBack.Caption := 'Close';
    btnBack.Color := clCrimson;
    btnBack.Font.Charset := DEFAULT_CHARSET;
    btnBack.Font.Color := clWhite;
    btnBack.Font.Height := -13;
    btnBack.Font.Name := 'Tahoma';
    btnBack.Font.Style := [fsBold];
    btnBack.HeightStyle := ssAuto;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.MaterialGlyphColor := clWhite;
    btnBack.ParentFont := False;
    btnBack.TabOrder := 0;
    btnBack.WidthPercent := 100.000000000000000000;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnSelect.SetParentComponent(WebPanel1);
    btnSelect.Name := 'btnSelect';
    btnSelect.Left := 18;
    btnSelect.Top := 38;
    btnSelect.Width := 108;
    btnSelect.Height := 35;
    btnSelect.Caption := 'Select';
    btnSelect.Color := clGreenyellow;
    btnSelect.Font.Charset := DEFAULT_CHARSET;
    btnSelect.Font.Color := clBlack;
    btnSelect.Font.Height := -13;
    btnSelect.Font.Name := 'Tahoma';
    btnSelect.Font.Style := [fsBold];
    btnSelect.HeightStyle := ssAuto;
    btnSelect.HeightPercent := 100.000000000000000000;
    btnSelect.MaterialGlyphColor := clWhite;
    btnSelect.ParentFont := False;
    btnSelect.TabOrder := 1;
    btnSelect.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelect, Self, 'OnClick', 'btnSelectClick');
    weSearch.SetParentComponent(WebPanel1);
    weSearch.Name := 'weSearch';
    weSearch.Left := 18;
    weSearch.Top := 6;
    weSearch.Width := 420;
    weSearch.Height := 22;
    weSearch.CharCase := wecUpperCase;
    weSearch.ChildOrder := 2;
    weSearch.Color := clWhite;
    weSearch.Font.Charset := DEFAULT_CHARSET;
    weSearch.Font.Color := clBlack;
    weSearch.Font.Height := -13;
    weSearch.Font.Name := 'Tahoma';
    weSearch.Font.Style := [];
    weSearch.HeightStyle := ssAuto;
    weSearch.HeightPercent := 100.000000000000000000;
    weSearch.ParentFont := False;
    weSearch.WidthPercent := 100.000000000000000000;
    SetEvent(weSearch, Self, 'OnChange', 'weSearchChange');
    gSearch.SetParentComponent(wpMain);
    gSearch.Name := 'gSearch';
    gSearch.Left := 0;
    gSearch.Top := 32;
    gSearch.Width := 480;
    gSearch.Height := 366;
    gSearch.Align := alClient;
    gSearch.ParentDoubleBuffered := False;
    gSearch.DoubleBuffered := True;
    gSearch.TabOrder := 1;
    SetEvent(gSearch, Self, 'OnClick', 'gSearchClick');
    gSearch.ShowAcceleratorChar := False;
    gSearch.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    gSearch.Header.VisualGrouping.Layout.Font.Height := -12;
    gSearch.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    gSearch.Header.VisualGrouping.Layout.Font.Style := [];
    gSearch.Adapter := dgaSearch;
    gSearch.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.FilterMatchLayout.Font.Height := -12;
    gSearch.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.FilterMatchLayout.Font.Style := [];
    gSearch.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    gSearch.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    gSearch.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.BandLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.BandLayout.Font.Height := -12;
    gSearch.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.BandLayout.Font.Style := [];
    gSearch.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.FixedLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.FixedLayout.Font.Height := -12;
    gSearch.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.FixedLayout.Font.Style := [];
    gSearch.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    gSearch.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.FixedSelectedLayout.Font.Style := [];
    gSearch.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.FocusedLayout.Font.Height := -12;
    gSearch.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.FocusedLayout.Font.Style := [];
    gSearch.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.GroupLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.GroupLayout.Font.Height := -12;
    gSearch.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.GroupLayout.Font.Style := [];
    gSearch.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.NormalLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.NormalLayout.Font.Height := -12;
    gSearch.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.NormalLayout.Font.Style := [];
    gSearch.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.SelectedLayout.Font.Height := -12;
    gSearch.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.SelectedLayout.Font.Style := [];
    gSearch.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    gSearch.CellAppearance.SummaryLayout.Font.Height := -12;
    gSearch.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    gSearch.CellAppearance.SummaryLayout.Font.Style := [];
    gSearch.ColumnCount := 5;
    gSearch.Columns.Clear;
    with gSearch.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Depot Code';
      Width := 0.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Depot Name';
      Width := 200.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Supplier Code';
      Width := 100.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Supplier Name';
      Width := 200.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Suspended';
      Width := 0.000000000000000000;
    end;
    gSearch.Designer := False;
    gSearch.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    gSearch.FilterAppearance.Font.Color := clWindowText;
    gSearch.FilterAppearance.Font.Height := -12;
    gSearch.FilterAppearance.Font.Name := 'Segoe UI';
    gSearch.FilterAppearance.Font.Style := [];
    gSearch.Icons.ExpandIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.ExpandIcon.svg');
    gSearch.Icons.CollapseIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.CollapseIcon.svg');
    gSearch.Icons.FilterIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.FilterIcon.svg');
    gSearch.Icons.FilterActiveIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.FilterActiveIcon.svg');
    gSearch.Icons.FilterClearIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.FilterClearIcon.svg');
    gSearch.Icons.FilterTypeIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.FilterTypeIcon.svg');
    gSearch.Icons.SortAscendingIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.SortAscendingIcon.svg');
    gSearch.Icons.SortDescendingIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.SortDescendingIcon.svg');
    gSearch.Icons.CloseIcon.LoadFromFile('search.dieseldepots.wpMain.gSearch.Icons.CloseIcon.svg');
    gSearch.Options.Selection.Mode := gsmSingleColumn;
    gSearch.RowCount := 1;
    dgaSearch.SetParentComponent(gSearch);
    dgaSearch.Name := 'dgaSearch';
    dgaSearch.Left := 264;
    dgaSearch.Top := 112;
    dgaSearch.Width := 26;
    dgaSearch.Height := 26;
    dgaSearch.Visible := True;
    dgaSearch.Columns.Clear;
    with dgaSearch.Columns.Add do
    begin
      FieldName := 'No';
      Header := 'Depot Code';
      AutoCreated := False;
    end;
    with dgaSearch.Columns.Add do
    begin
      FieldName := 'Name';
      Header := 'Depot Name';
      AutoCreated := False;
    end;
    with dgaSearch.Columns.Add do
    begin
      FieldName := 'SupplierCode';
      Header := 'Supplier Code';
      AutoCreated := False;
    end;
    with dgaSearch.Columns.Add do
    begin
      FieldName := 'SupplierName';
      Header := 'Supplier Name';
      AutoCreated := False;
    end;
    with dgaSearch.Columns.Add do
    begin
      FieldName := 'Suspended';
      Header := 'Suspended';
      AutoCreated := False;
    end;
    dgaSearch.DataSource := dsSearch;
    wcSearch.SetParentComponent(Self);
    wcSearch.Name := 'wcSearch';
    wcSearch.Connection := dmData.dbConnect;
    wcSearch.Left := 152;
    wcSearch.Top := 104;
    qSearch.SetParentComponent(Self);
    qSearch.Name := 'qSearch';
    qSearch.AfterOpen := qSearchAfterOpen;
    qSearch.Connection := dmData.dbConnect;
    qSearch.Left := 376;
    qSearch.Top := 96;
    qSearchNo.SetParentComponent(qSearch);
    qSearchNo.Name := 'qSearchNo';
    qSearchNo.FieldName := 'No';
    qSearchName.SetParentComponent(qSearch);
    qSearchName.Name := 'qSearchName';
    qSearchName.FieldName := 'Name';
    qSearchSuspended.SetParentComponent(qSearch);
    qSearchSuspended.Name := 'qSearchSuspended';
    qSearchSuspended.FieldName := 'Suspended';
    qSearchSupplierName.SetParentComponent(qSearch);
    qSearchSupplierName.Name := 'qSearchSupplierName';
    qSearchSupplierName.FieldName := 'SupplierName';
    qSearchSupplierCode.SetParentComponent(qSearch);
    qSearchSupplierCode.Name := 'qSearchSupplierCode';
    qSearchSupplierCode.FieldName := 'SupplierCode';
    dsSearch.SetParentComponent(Self);
    dsSearch.Name := 'dsSearch';
    dsSearch.AutoEdit := False;
    dsSearch.DataSet := qSearch;
    dsSearch.Left := 424;
    dsSearch.Top := 104;
  finally
    wpMain.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    btnSelect.AfterLoadDFMValues;
    weSearch.AfterLoadDFMValues;
    gSearch.AfterLoadDFMValues;
    dgaSearch.AfterLoadDFMValues;
    wcSearch.AfterLoadDFMValues;
    qSearch.AfterLoadDFMValues;
    qSearchNo.AfterLoadDFMValues;
    qSearchName.AfterLoadDFMValues;
    qSearchSuspended.AfterLoadDFMValues;
    qSearchSupplierName.AfterLoadDFMValues;
    qSearchSupplierCode.AfterLoadDFMValues;
    dsSearch.AfterLoadDFMValues;
  end;
end;

end.
